const Cart = {
	state: {
    	cart_total_items: 0,
    	cart_items:[],
		cart_sub_total:0,
		cart_tax:0,
		cart_total_amount:0
  	},
  	mutations:{
  		add_to_cart(state,item){
  			state.cart_items.push(item);
  			state.cart_total_items += item.qty;
  		},
  		empty_cart(state){
  			state.cart_total_items = 0;
  			state.cart_items = [];
			state.cart_sub_total = 0;
			state.cart_tax = 0;
			state.cart_total_amount = 0;
  		},
		update_sub_total(state,amount){
			state.cart_sub_total = amount;
		},
		update_tax(state,tax){
			state.cart_tax = tax;
		},
		update_cart_total_amount(state,amount){
			state.cart_total_amount = amount;
		},
  		add_qty(state,item){
  			if(item.type=="increase"){
  				item.course.qty += item.qty;
  				state.cart_total_items += item.qty;
  			}
  			else{
  				item.course.qty -= item.qty;
  				state.cart_total_items -= item.qty;
  			}
  		},
  		update_qty(state,item){
  			if(item.qty > 0){
  				item.course.qty = item.qty;
  				state.cart_total_items -= item.old_qty;
  				state.cart_total_items += item.qty;
  			}
  			else{
  				var removeIndex = state.cart_items.map(function(item) { return item.id; }).indexOf(item.course.id);
	  			state.cart_items.splice(removeIndex, 1);
	  			state.cart_total_items = state.cart_items.length;
  			}
  		},
  		remove_form_cart(state,course_id)  {
  			var removeIndex = state.cart_items.map(function(item) { return item.id; }).indexOf(course_id);
  			state.cart_items.splice(removeIndex, 1);
  			state.cart_total_items = state.cart_items.length;
  		},
  	},
  	getters: {
  		cart_items: (state) => {
    		return state.cart_items;
  		}
  	}
}
export default Cart;


// WEBPACK FOOTER //
// ./src/store/Cart.js